export class CalendarRange {
    start: Date;
    end: Date;
    weekday: string;

    public static Make(obj: any): CalendarRange {
        const calendarRange = new CalendarRange();
        Object.assign(calendarRange, obj);
        calendarRange.start = ConvertToDate(obj.start);
        calendarRange.end = ConvertToDate(obj.end);
        return calendarRange;
    }
}

export const ConvertToDate = (dateString: string): Date => {
    const year = Number(dateString.slice(0, 4));
    const month = Number(dateString.slice(4, 6)) - 1;
    const day = Number(dateString.slice(6, 8));
    const hour = Number(dateString.slice(9, 11));
    const minutes = Number(dateString.slice(12, 14));
    return new Date(year, month, day, hour, minutes);
};
